import React from 'react'
import { Modal } from '@mantine/core'

const CustomModal = function ({ open, onClose, children }) {
  return (
    <Modal
      opened={open}
      onClose={onClose}
      overflow="inside"
      styles={() => ({
        modal: {
          border: '1px solid #1DC28B',
          background: 'rgba(15,21,36,0.90)',
          boxShadow: 'inset 0 1px 20px 0 rgba(51,238,233,0.50)',
          color: '#fff',
          borderRadius: '0px',
        },
        close: {
          color: '#1DC28B',
          '&:hover': {
            background: 'none',
          },
          '&:focus-visible': {
            outline: 'none',
          },
        },
      })}
    >
      {children}
    </Modal>
  )
}

export default CustomModal
